import React, { Component } from 'react';
import { Helmet } from 'react-helmet';

import WithUser from '../WithUser';
import { roles } from '../../helpers/auth';
import { selectors as portaleSelectors } from '../../reducers/currentPortale';
import WidgetUltimeModifichePortale from 'components/widget/WidgetUltimeModifichePortale';
import WidgetSelectGestione from 'components/widget/WidgetSelectGestione';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';
import SelectPortaleV2 from '../SelectPortaleV2';

class DashboardGestionalePortali extends Component {
    render() {
        const { user, userRole } = this.props;

        if (!user) {
            return <span>Perfavore effettua il login</span>;
        }

        const isUser = userRole === roles.user;

        const showPortaleFilter = !isUser;

        return (
            <div className="row py-2">
                <div className="col-12 pb-4">
                    <Helmet>
                        <title>{`Gestionale portali`}</title>
                    </Helmet>
                    <h2 className="text-primary text-center">
                        Seleziona il portale da gestire
                    </h2>
                </div>
                {showPortaleFilter && (
                    <WidgetSelectGestione title="Gestisci Portale">
                        <SelectPortaleV2 />
                    </WidgetSelectGestione>
                )}
                <div className="col-md-6">
                    <WidgetUltimeModifichePortale />
                </div>
                <div className="col-md-6">
                    <WidgetUltimeModifichePortale />
                </div>
            </div>
        );
    }
}

export default withRouter(
    connect((state) => ({
        currentPortale: portaleSelectors.getCurrentPortale(state),
    }))(WithUser(DashboardGestionalePortali))
);
